// Turbo Frames expect the response to contain the frame they navigated. When
// the server instead redirects to a page without it (e.g. the checkout state
// guard sends an address-form submission from a stale, history-restored
// "shipping address" page back to the "shipping method" step), Turbo drops
// the response and throws an unhandled rejection. Promote such responses to a
// full-page visit instead, so the user lands on the page the server chose.
//
// Handlers that already took care of the event (event.defaultPrevented) are
// left alone.
function handleFrameMissing(event) {
  if (event.defaultPrevented) return

  const { response, visit } = event.detail
  event.preventDefault()
  visit(response)
}

document.addEventListener("turbo:frame-missing", handleFrameMissing)
